import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { services } from '../../lib/constants';

const ServicesShowcase = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="py-16 md:py-24 bg-neutral-950">
      <div className="container mx-auto px-4 md:px-6">
        <motion.h2
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-white mb-8 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          What We Do
        </motion.h2>

        <div className="overflow-x-auto scrollbar-hide mb-8 md:mb-12 -mx-4 px-4 md:mx-0 md:px-0">
          <div className="flex md:flex-wrap md:justify-center gap-3 md:gap-4 min-w-max md:min-w-0 py-2">
            {services.map((service, index) => (
              <motion.button
                key={index}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold transition-all whitespace-nowrap text-sm md:text-base ${
                  activeTab === index
                    ? 'bg-white text-black shadow-lg'
                    : 'bg-white/5 text-white hover:bg-white/10 border border-white/10'
                }`}
                onClick={() => setActiveTab(index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {service.name}
              </motion.button>
            ))}
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center max-w-6xl mx-auto"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6">
                {services[activeTab].name}
              </h3>
              <p className="text-base md:text-lg text-neutral-400 mb-6 md:mb-8 leading-relaxed">
                {services[activeTab].description}
              </p>
            </div>

            <motion.div
              className="relative rounded-2xl overflow-hidden shadow-2xl"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: 0.1 }}
            >
              <div className="aspect-video border border-white/10">
                <img
                  src={services[activeTab].image}
                  alt={services[activeTab].name}
                  className="w-full h-full object-cover grayscale"
                />
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default ServicesShowcase;